import {Component} from '@angular/core';
import {ProductSearchPage, RoutingService} from '@spartacus/core';
import {ProductFacetService} from '@spartacus/storefront';
import {combineLatest, Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';

import {AimoFacet, AimoFacetValue} from '../../../../model/product.model';
import {AimoProductListComponentService} from '../../../../service/product/aimo-product-list-component.service';
import {AimoFacetService} from "../../../../service/product/aimo-facet.service";

@Component({
    selector: 'aimo-product-categories',
    templateUrl: './aimo-product-categories.component.html',
    standalone: false
})
export class AimoProductCategoriesComponent {
    showAllCategories = false;

    model$: Observable<ProductSearchPage>;

    facets$: Observable<AimoFacet>;

    categoryLevel2Title$: Observable<string>;

    constructor(
        protected productFacetService: ProductFacetService,
        protected productListComponentService: AimoProductListComponentService,
        protected routingService: RoutingService,
        protected facetService: AimoFacetService
    ) {
        this.model$ = this.productListComponentService.model$;

        this.facets$ = combineLatest(
            [this.productFacetService.facetList$]
        ).pipe(
            switchMap(([list]) => {
                    const CATEGORY_FACET_NAME = this.getCategoryFacetCode(list.facets);
                    return list.facets.filter((facet) => (facet as AimoFacet).code === CATEGORY_FACET_NAME).length == 0
                        ? [{code: CATEGORY_FACET_NAME, values: []} as AimoFacet] //clear category facets for  searches, which do not result values
                        : list.facets.filter((facet) => (facet as AimoFacet).code === CATEGORY_FACET_NAME)
                }
            ),
        );

        this.categoryLevel2Title$ = this.facetService.getCategoryLevel2Title();
    }

    getCategoryFacetCode(facets: AimoFacet[]): string {
        return facets.filter(f => f.code === 'categoryLevel2').flatMap(f => f.values).length === 1 ? 'category' : 'categoryLevel2';
    }

    toggleShowAllCategories(showAllCategories: boolean): void {
        this.showAllCategories = showAllCategories;
    }

    openRootCategory(): void {
        this.routingService.go('/category/0');
    }

    protected isLowestLevelSelected(facet: AimoFacet) {
        return facet.code === 'category';
    }

    getBackLinkFacet(): Observable<AimoFacetValue> {
        return this.facetService.getSelectedCategoryLevel2();
    }
}
